import { DateHelper } from "../Common/DateHelper";
import { ODataSelect } from "./ODataQuery";

export class SignPost extends ODataSelect
{
    ShortcutId = '';
    SignPostType = '';
    Heading = '';
    Application: ApplicationType[] = [];
    Label = '';
    SubHeading = '';
    BuildingKPI_Order = 0;
    Destination: IDestination = {
        Web: '',
        Android: '',
        iOS: ''
    };
    Image = '';
    Node_Id = 0;
    IsEnabled = 0;

    public init(response: any, nodeId: number): SignPost
    {
        super.init(response, nodeId);
        return this;
    }
}

export enum ApplicationType
{
    flex = "Flex",
    roamer = "Roamer",
}
export interface IDestination
{
    Web: string;
    Android: string;
    iOS: string;
}

export class Announcement extends ODataSelect
{
    public Notification_Id = 0;
    public Notification_Title = '';
    public Notification_Priority = 0;
    public Notification_Record_Id = '';
    public Notification_Message = '';
    public Notification_Short_Message = '';
    public Notification_Reminders =  "";
    public Notification_Type = 0;
    public Notification_Status = '';
    public Notification_User_Email = '';
    public Notification_Sent = 0;
    public Notification_Target = 0;
    public Notification_Device = null;
    public Classification = '';
    public Subclassification = '';
    public Available_From = DateHelper.null();
    public Expiry_Date = DateHelper.null();
    public Has_Image = 0;
    public ImageURI = '';
    public ActionURI = '';
    public Node_Id = 0;

    public init(response: any, nodeId: number): Announcement
    {
        super.init(response, nodeId);
        this.Available_From = DateHelper.fromIsoByNode(response.Available_From, nodeId);
        this.Expiry_Date = DateHelper.fromIsoByNode(response.Expiry_Date, nodeId);
        return this;
    }
}